import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=312a0b9c&scoped=true&"
import script from "./Transactions.vue?vue&type=script&lang=ts&"
export * from "./Transactions.vue?vue&type=script&lang=ts&"
import style0 from "./Transactions.vue?vue&type=style&index=0&id=312a0b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312a0b9c",
  null
  
)

export default component.exports